import { render, staticRenderFns } from "./search_orders.vue?vue&type=template&id=6e68fda5&"
import script from "./search_orders.vue?vue&type=script&lang=js&"
export * from "./search_orders.vue?vue&type=script&lang=js&"
import style0 from "./search_orders.vue?vue&type=style&index=0&id=6e68fda5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports